<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="单据类型">
              <a-input placeholder="单据类型" v-model="queryParam.billType"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="单据编号">
              <a-input placeholder="单据编号" v-model="queryParam.billNumber"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="文件名称">
              <a-input placeholder="请输入文件名称" v-model="queryParam.fileName"></a-input>
            </a-form-item>
          </a-col>

          <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
               <a-col :md="6" :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
               </a-col>
            </span>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleDeleteAll()" type="primary" >清除全部</a-button>
    </div>

    <!--table区 -->
    <div>
      <!--已选择的清空 -->
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys,onChange: onSelectChange}"
        @change="handleTableChange"
      >
        <!-- 字符串超长截取省略号显示-->
        <template slot="opTypeSlot" slot-scope="text, record">
          <span>{{getOpType(record)}}</span>
        </template>
        <span slot="dataContent" slot-scope="text, record">
          <j-ellipsis :value="text" :length="80" />
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDelete(record)">删除</a>
        </span>
      </a-table>
    </div>
  </a-card>
</template>

<script>
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import JEllipsis from "@/components/jeecg/JEllipsis";
  import { postAction } from '@/api/manage'

  export default {
    name: 'FileOperationLogList',
    mixins: [JeecgListMixin],
    components: {
      JEllipsis,
    },
    data() {
      return {
        description: '文件操作日志管理',
        //表头
        columns: [
          {
            title: '文件名称',
            align: 'center',
            dataIndex: 'fileName',
            width: "120",
            scopedSlots: {customRender: 'dataContent'},
          }, {
            title: '操作类型',
            align: 'center',
            dataIndex: 'opType',
            width: "80",
            scopedSlots: {customRender: 'opTypeSlot'},
          },
          /*{
            title: '单据类型',
            align: 'center',
            dataIndex: 'billType',
            width: "80"
          },  {
            title: '单据编号',
            align: 'center',
            dataIndex: 'billNumber',
            width: "80"
          },*/
          {
            title: '创建人',
            align: 'center',
            dataIndex: 'createBy',
            width: "100"
          },
          {
            title: '创建时间',
            align: 'center',
            dataIndex: 'createTime',
            width: "100"
          },
          {
            title: '操作',
            align:'center',
            width: '80',
            scopedSlots: {customRender: 'action'},
          }
        ],
        url: {
          list: "/sys/fileOperationLog/list",
          deleteFile:"/sys/fileOperationLog/clear",
        },
      }
    },
    methods: {
      // 删除所有记录和文件
      handleDeleteAll(){
        if(this.dataSource.length <=0){
          return;
        }

        let that = this
        this.$confirm(
          {
            title: '确认删除',
            content: '确定要删除当前公司吗?',
            onOk: function() {
              postAction(that.url.deleteFile, {}).then(res => {
                if(res.success){
                  that.$message.info("清除完成")
                  that.loadData()
                } else{
                  that.$message.warn("清除文件错误:" + res.message)
                }
              })
            }
          })
      },

      handleDelete(record){
        if(!record){
          return
        }

        postAction(this.url.deleteFile, {id: record.id}).then(res => {
          if(res.success){
            this.$message.info("清除完成")
            this.loadData()
          } else{
            this.$message.warn("清除文件错误:" + res.message)
          }
        })
      },

      getOpType(record){
        if(record.opType == '0'){
          return '新增'
        } else{
          return '未知'
        }
      },
    }

  }

</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>